import { render } from "./BaseRadio.vue?vue&type=template&id=7ea735bb"
import script from "./BaseRadio.vue?vue&type=script&lang=js"
export * from "./BaseRadio.vue?vue&type=script&lang=js"
script.render = render

export default script